import React, { useContext } from 'react'
import { DemoContext } from '../lib/DemoProvider'
import { SideNav, SideNavItem } from '@react/react-spectrum/SideNav'
import {
    getDebugMode
} from '../lib/lib'

export default function DemoMenu () {
    const { dispatch } = useContext(DemoContext)
    const dMode = getDebugMode() || false
    function goToFeaturePage (page) {
        console.log(`${page} clicked`)
        switch (page) {
        case 'feedback':
            window.open('https://psd-services.zendesk.com/hc/en-us/requests/new', '_blank')
            break
        default:
            dispatch({ type: 'set-page', payload: { page } })
            window.history.replaceState(null, null, `?ref=${page}`)
        }
    }

    return <SideNav variant="multiLevel" onSelect={page => goToFeaturePage(page)} expanded={false}>
        <SideNavItem value="refinecutout" label="Remove Background" expanded>
            <SideNavItem value="home" label="Get Started - API" />
            <SideNavItem value="standalone" label="Get Started - Editor" />
            <SideNavItem value="integrationhtml" label="Integration" />
            <SideNavItem value="demoapp" label="Demo" />
            { dMode ? <SideNavItem value="demohtml" label="Demo - HTML" /> : <SideNavItem></SideNavItem>}
        </SideNavItem>
        <SideNavItem value="contact" label="Contact us" expanded>
            <SideNavItem value="feedback" label="Send Feedback" />
        </SideNavItem>
    </SideNav>
}
